import { Component, AfterViewInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';

import * as intlTelNumber from 'intl-tel-input';
declare var $: any;



export class HjIntlTelInputComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {
	 public class: string = 'form-control';
	 public name: string = 'Phone Number';
	 public phoneNumber: string = '';
	 public placeholder: string = '';
	 public separateDialCode: boolean = true;
	 public preferredCountries: string[] = ['gb', 'us'];

	 public phoneElmRef: ElementRef;

	// The internal data model
	private innerValue: any = '';
	private phoneIntl: any;

	public propagateChange = (_: any) => undefined;
	public propagateTouch = () => undefined;

	public ngAfterViewInit() {
		this.initPhoneInput();
	}

	public ngOnDestroy() {
		if (this.phoneIntl) {
			this.phoneIntl.destroy();
			this.phoneIntl = null;
		}
	}

	// Placeholders for the callbacks which are later provided by the Control Value Accessor
	// Get accessor
	public get value(): any {
		return this.innerValue;
	};

	/* tslint:disable */
	// Set accessor including call the onchange callback
	public set value(v: any) {
		if (v !== this.innerValue) {
			this.innerValue = v;
			this.propagateChange(this.innerValue);
			this.propagateTouch();
		}
	}
	/* tslint:enable */

	// From ControlValueAccessor interface
	public writeValue(value: any) {
		if (value !== this.innerValue) {
			this.innerValue = value;
		}
	}

	// From ControlValueAccessor interface
	public registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	// From ControlValueAccessor interface
	public registerOnTouched(fn: any) {
		this.propagateTouch = fn;
	}

	// Validation
	public validate(c: FormControl) {
		if (!this.phoneIntl) {
			return null;
		}

		if (this.phoneIntl.isPossibleNumber()) {
			return null;
		}

		return {
			invalid:  this.phoneIntl.getValidationError()
		};
	}

	public onInputBlur() {
		if (!this.phoneIntl) {
			return null;
		}

		this.phoneIntl.setNumber(this.phoneIntl.getNumber());
		this.propagateChange(this.phoneIntl.getNumber());
		this.propagateTouch();
	}

	private async initPhoneInput() {
		this.phoneIntl = intlTelNumber(this.phoneElmRef.nativeElement, {
			separateDialCode: this.separateDialCode,
			preferredCountries: this.preferredCountries
		});
		await (<any> window).intlTelInputGlobals.loadUtils('assets/intl-tel-input/js/utils.js');

		this.phoneIntl.setNumber(this.phoneNumber || '');

		this.phoneElmRef.nativeElement.addEventListener('countrychange', (e) => {
			this.propagateChange(this.phoneIntl.getNumber());
		});
		setTimeout(() => {
			this.phoneIntl.setNumber(this.phoneNumber || '');
		}, 30);
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/components/hj-intl-tel-input/hj-intl-tel-input.component.ts